import './services/firebase';

import { HeartTwoTone } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { Layout } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { Provider } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { ApiLimitModalListener } from './components/ApiLimitModal';
import Menu from './components/Menu';
import { NewGameModeHelp } from './components/NewGameModeHelp';
import RouterSwitch from './components/RouterSwitch';
import { isInGameRoute, routeNames } from './constants/routes';
import store, { persistor } from './redux/store';

const { Footer } = Layout;

export const App = () => {
    // init google analytics
    if (process.env.NODE_ENV === 'production') {
        if (process.env.REACT_APP_SENTRY_DNS) {
            Sentry.init({
                dsn: process.env.REACT_APP_SENTRY_DNS,
                integrations: [new BrowserTracing()],
                environment: process.env.NODE_ENV,
                // We recommend adjusting this value in production, or using tracesSampler for finer control
                tracesSampleRate: 0.3,
            });
        }
    }
    const location = useLocation();
    const { pathname } = location;

    const isInGame = isInGameRoute(pathname);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ApiLimitModalListener />
                <Menu isInGame={isInGame} />
                <Layout className={classNames(!isInGame && 'layout')}>
                    <RouterSwitch />
                </Layout>
                {!isInGame && (
                    <Footer className="site-footer">
                        <div className="footer-promo">
                            <span className="footer-promo-label">
                                Vývoj KdeToSakra sponzoruje <HeartTwoTone twoToneColor="#eb2f96" />
                            </span>
                            <a
                                href="https://zenamu.com"
                                target="_blank"
                                rel="noreferrer"
                                className="footer-promo-button"
                            >
                                <span className="footer-promo-button-text">Zenamu</span>
                                <span className="footer-promo-button-desc">
                                    Rezervační systém a platforma pro studia, lektory a individuální praxi.
                                </span>
                            </a>
                        </div>
                        <div className="footer-bottom">
                            <p className="footer-credits">
                                Postaveno na <a href="https://api.mapy.cz/">Mapy.cz API</a>
                            </p>
                            <div className="footer-links">
                                <Link to={`/${routeNames.podminky}`}>Podmínky</Link>
                                <span className="footer-divider">•</span>
                                <Link to={`/${routeNames.cookies}`}>Cookies</Link>
                            </div>
                        </div>
                    </Footer>
                )}
            </PersistGate>
        </Provider>
    );
};
